import { render, staticRenderFns } from "./agentForm.vue?vue&type=template&id=80a6a90e&scoped=true&"
import script from "./agentForm.vue?vue&type=script&lang=js&"
export * from "./agentForm.vue?vue&type=script&lang=js&"
import style0 from "./agentForm.vue?vue&type=style&index=0&id=80a6a90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a6a90e",
  null
  
)

export default component.exports